import { IOption } from 'src/components/ui-kit/ReactSelect';

/** 資料錯誤通報。 */
export interface IReqInform {
  /** 開放資料名稱。*/
  dataSetId: string | number;
  /** 姓名。*/
  name: string;
  /** 電子郵件信箱。*/
  email?: string;
  /** 問題描述。 */
  description: string;

  /** 識別碼。 */
  captchaUuid: string;

  /** 驗證碼。 */
  captchaCode: string;
}

export const InformOptions: IOption[] = [
  { value: 'QR01', label: '專利權證資料' },
  { value: 'QR02', label: '商標權證資料' },
];
